const copyToClipboard = (clipboardText: string) => {
	let copySuccess = false;
	if ('clipboard' in navigator) {
		navigator.clipboard.writeText(clipboardText);
		copySuccess = true;
	}
	return copySuccess;
}

export {
	copyToClipboard,
};
